import { mapState } from "vuex";
import { Loading } from "element-ui";
import logistics_dtl from "@/views/order/module/logisticsInfo";
import order_seller from "@/views/order/orderDialog/orderSeller";
import contract_sign from "@/views/order/orderDialog/contractSign.vue";
import QrCode from "qrcode";
import { uuid, isMobile } from "@/utils/utils";
import requestApi from "@/utils/requestApi";
import ShippingOptions from "@/views/order/orderDialog/shippingOptions/shippingOptions.vue";
import contractPreview from "@/components/contractPreview/contractPreview.vue";

const { VUE_APP_APP } = process.env;

let imgTransferTimer = null;
let uuidStr = 0;

export default {
  components: {
    logistics_dtl,
    order_seller,
    contract_sign,
    ShippingOptions,
    contractPreview,
  },
  data() {
    return {
      loaded: false,
      env: process.env,
      orderId: "",
      detail: {
        orderTransportDtlBo: {
          linkman: "",
        },
        orderDtlBo: {
          orderInvoice: {},
        },
      },
      buttonList: [],
      orderDelivery: [],
      orderGoodsList: [],
      orderGoodsGiftBoList: [],
      cfyCard: "0",
      tabsActive: "order1",
      thisOrderGoodsNum: 0,
      thisOrderGoodsMoney: 0,
      sellerVoucherPicList: [],
      memoSeller: "",
      invoiceFileList: [],
      /*订单快照*/
      editOrderSnapshotDialogVisible: false,

      /*手机传图*/
      signatureDialogVisible: false,

      submitSellerVoucherLoading: false,
      /**
       * 确认自提时间
       */
      dialogFormVisiblePickupTime: false,
      pickupTimeBtn: "确定",
      selectPickupTime: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24 * 21;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "后天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      showConfirmPickupType: 1,
      // sellerConfirmPickupPeriod: "上午",
      sellerConfirmPickupWarehouse: "",

      contractPreviewUrl: "",
      contractPreviewVisible: false,
      // 质量扣补
      allowanceVisible: false,
      allowanceForm: {
        orderId: "",
        kbAmount: undefined,
        vehicleId: 0,
        kbRemark: "",
      },
      allowanceFormRules: {
        kbAmount: [
          { required: true, message: '请输入质量扣补', trigger: 'change' }
        ],
      },

      vehicleListCollapse: false,
      // 预订单入库通知操作记录
      noticeOperationRecord: null,
      // 预订单入库验收操作记录
      acceptanceOperationRecord: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
    /**
     * 是否展示预订单入库通知/验收模块
     *
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    showPreOrderInboundInfo() {
      return !!(this.noticeOperationRecord || this.acceptanceOperationRecord);
    },
  },
  created() {
    this.orderId = this.$route.params.id || 0;

    if (isMobile()) {
      window.location.href = `${VUE_APP_APP}vm2/order/seller/orderDetail/index?orderId=${this.orderId}`;
      return;
    }

    // this.selRefundOrderGoodsList();
    this.queryOrderDetail();

    const body = document.querySelector("body");
    body.classList.add("seller-style");
  },

  methods: {
    handlePurchaseOrderClick(row) {
      console.log("row: ", row);
      let orderId = row.orderId;
      window.open(`${process.env.VUE_APP_APP}v/order/detail/${orderId}`);
    },
    showConfirmPickup(type, type2) {
      this.showConfirmPickupType = type2;
      if (type == 1) {
        this.pickupTimeBtn = "确定修改";
      } else {
        this.pickupTimeBtn = "确定";
      }
      this.dialogFormVisiblePickupTime = true;
    },
    savePickupTime: function () {
      if (!this.selectPickupTime) {
        this.$message({
          message: `请选择${this.showConfirmPickupType == "1" ? "预计发货时间" : "提货时间"}`,
          type: "warning",
        });
        return;
      }
      this.loading = this.$loading({
        lock: false,
        text: "处理中...",
      });
      console.log("this.selectPickupTime", this.selectPickupTime);
      const arg = {
        orderId: this.orderId,
        sellerConfirmPickupTime: this.selectPickupTime,
      };
      if (this.showConfirmPickupType != "1") {
        // arg.sellerConfirmPickupPeriod = this.sellerConfirmPickupPeriod;
        arg.sellerConfirmPickupWarehouse = this.sellerConfirmPickupWarehouse;
      }
      this.$store.dispatch("orderTo/index/confirmSelfPickupTime", arg).then((res) => {
        this.loading.close();
        if (res.code == "0") {
          const data = res.data;
          if (data && data.isPass === false) {
            this.$confirm(data.tips || "提示", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                if (data.url) {
                  window.location.href = data.url;
                }
              })
              .catch(() => {});
            return;
          }
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogFormVisiblePickupTime = false;
          this.detail.orderTransportDtlBo.sellerConfirmPickupTimeStr = this.selectPickupTime && this.selectPickupTime.split(" ")[0];
          // this.detail.orderTransportDtlBo.sellerConfirmPickupPeriod = this.sellerConfirmPickupPeriod;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    buttonSubmit(item, detail) {
      console.log("button", item, detail);
      switch (item.buttonCode) {
        case "to_confirm_self_delivery":
          this.$refs.order_seller_dialog.confirmSelfDelivery(item);
          return;
        case "to_confirm_receipt_confirmation":
          this.$refs.order_seller_dialog.selRefundOrderGoodsList();
          return;
        case "to_change_price":
          this.$refs.order_seller_dialog.editPriceOpen(item);
          return;
        case "to_cancel":
          this.orderCancel();
          return;
        case "to_deliver_goods":
          if (item.isAllowDeliver == 1) {
            if (detail.sendSt == 3) {
              this.$router.push({
                path: "/seller/logistics",
                query: { orderId: item.orderId, type: 1 },
              });
            } else {
              this.$refs.shippingOptionsRef.open(item.orderId);
            }
            // eslint-disable-next-line max-len
            //window.location.href = `${process.env.VUE_APP_APP}mj/order/manage/deliverOrderGoods?orderId=${item.orderId}`;
          } else {
            this.$message.error("该订单为付款人代下的订单，需要被代下单人填写上收货地址后，您才能发货，有疑问请联系付款人或平台客服。");
          }
          return;
        case "to_read_ping_jia":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/orderComment?orderId=${item.orderId}`);
          return;
        case "to_build_contract":
          this.$refs.contract_sign_dialog.getContractData(item.orderId, true, { ...item, buildContractVisible: true }, true);
          return;
        case "to_read_contract":
          this.$refs.contract_sign_dialog.viewContract(item);
          //window.open(`${process.env.VUE_APP_APP}contract/toEcontrantDetail?id=${item.contractId}&isBuyer=2`);
          return;
        case "to_sign_material":
          this.$refs.order_seller_dialog.editBalanceConfirmationOpen();
          return;
        case "to_read_material":
          window.open(`${process.env.VUE_APP_APP}contract/toMaterialConfirmationDetail?id=${item.orderId}&isBuyer=0`);
          return;
        case "to_create_sales_slip":
          window.open(`${item.salesSlipUrl}${item.orderId}`);
          return;
        case "to_read_sales_slip":
          window.open(`${item.salesSlipUrl}${item.orderId}`);
          return;
        case "to_read_refund":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}v/aftersales/detail/${item.refundOrderId}?orderId=${item.orderId}`
          );
          return;
        case "to_order_purchase":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/orderPurchase?orderId=${item.orderId}`);
          return;
        case "to_order_wu_liu":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/toLogisticsDetail?orderId=${item.orderId}`);
          return;
        // 修改发货信息
        case "to_modify_delivery_info":
          this.$refs.order_seller_dialog.editDeliveryInfoOpen(`${item.orderId}`);
          return;
        //签收单
        case "to_order_receipt":
          window.open(`${item.url}`);
          return;
        // 代采订单--提货完成
        case "to_behalf_purchase_pick_up":
          this.behalfPurchasePickup();
          return;
        // 预订单--终止提货
        case "to_finish_pick_up_yyd":
          this.$confirm('操作后，客户将无法基于此预订单继续提货<br />确认是否操作？', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          }).then(async () => {
            const loading = this.$loading({
              lock: true,
              text: "加载中...",
            });
            const { code, msg } = await requestApi.post(`sctrading/order/mj/finished`, {
              orderId: this.orderId,
            });
            loading.close();
            if (code != '0') {
              this.$message.error(msg);
              return;
            }
            this.$message({
              type: 'success',
              message: '操作成功'
            });

            setTimeout(() => {
              window.location.reload();
            }, 500);
          }).catch(() => {});
          return;
        default:
          this.$message.error("无效按钮");
          return;
      }
    },
    /**
     * 查询预订单操作记录
     *
     * @param busType 业务类型
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    async selPreOrderOperationRecord(busType) {
      try {
        const { code, data } = await requestApi.post("scbasic/operation/operationrecord/selOperationRecordListByParam", {
          busId: this.orderId,
          busType,
        });
        // 取集合最后一条作为最新记录
        if (code === "0" && data && data.length > 0) {
          return data[data.length - 1];
        }
      } catch (e) {
        console.error("selPreOrderOperationRecord error", e);
      }
      return null;
    },
    /**
     * 加载预订单入库通知和验收信息
     *
     * @Auther SongYapeng
     * @Date 2026/6/11
     */
    async loadPreOrderOperationRecords() {
      const [noticeOperationRecord, acceptanceOperationRecord] = await Promise.all([
        this.selPreOrderOperationRecord("YDD_NOTICE_TEMPLATE_MERCHANT"),
        this.selPreOrderOperationRecord("YDD_NOTICE_TEMPLATE_BUYER"),
      ]);
      this.noticeOperationRecord = noticeOperationRecord;
      this.acceptanceOperationRecord = acceptanceOperationRecord;
    },
    queryOrderDetail() {
      let loadingInstance1 = Loading.service({ fullscreen: true, customClass: "seller-style" });
      this.$store.dispatch("orderTo/index/selOrderSellerDetailByOrderId", { orderId: this.orderId }).then((data) => {
        console.log(data);
        if (data) {
          if (data.vehicleList && data.vehicleList.length) {
            data.vehicleList.forEach((item) => {
              item.actualSendQuantity = item.pickupQuantity;
            })
          }
          this.detail = data;
          this.memoSeller = this.detail.memoSeller;
          this.orderGoodsGiftBoList = data.orderGoodsGiftBoList || [];
          // 预订单加载入库通知和验收操作记录
          if (data.orderDtlBo && data.orderDtlBo.orderType == 4) {
            this.loadPreOrderOperationRecords();
          }
          Promise.all([
            this.$store.dispatch("orderTo/index/selSellerButtonDetailByOrderId", { orderId: this.orderId }),
            this.$store.dispatch("orderTo/index/selDeliveryDetailByOrderId", { orderId: this.orderId }),
            this.$store.dispatch("orderTo/index/selOrderGoodsListByOrderId", { orderId: this.orderId }),
          ]).then(([res1, res2, res3]) => {
            this.buttonList = res1;
            this.orderDelivery = res2;
            this.orderGoodsList = res3;
            this.orderGoodsList.forEach((item) => {
              this.thisOrderGoodsNum = parseFloat((this.thisOrderGoodsNum + item.goodsQuantity).toFixed(10));
              this.thisOrderGoodsMoney = this.thisOrderGoodsMoney + Number(item.sellFactPrice * item.goodsQuantity);
              if (item.cfyCard === "1") {
                this.cfyCard = item.cfyCard;
              }
              item.finalSettlementPrice =
                Number(item.finalSettlementPrice) != Number(item.sellFactPrice) && Number(item.finalSettlementPrice) > 0
                  ? item.finalSettlementPrice
                  : item.sellFactPrice;
              item.finalSettlementQuantity =
                Number(item.finalSettlementQuantity) != Number(item.goodsQuantity) && Number(item.finalSettlementQuantity) > 0
                  ? item.finalSettlementQuantity
                  : item.goodsQuantity;
              this.finalSettlementMoney = Number(this.finalSettlementMoney) + Number(item.finalSettlementQuantity * item.finalSettlementPrice);
            });
            this.loaded = true;
            loadingInstance1.close();

            if (data.orderTransportDtlBo.sellerConfirmPickupTime) {
              this.selectPickupTime = data.orderTransportDtlBo.sellerConfirmPickupTime;
            }
            if (data.orderTransportDtlBo.sellerConfirmPickupWarehouse) {
              this.sellerConfirmPickupWarehouse = data.orderTransportDtlBo.sellerConfirmPickupWarehouse;
            }
            // if (data.orderTransportDtlBo.sellerConfirmPickupPeriod) {
            //   this.sellerConfirmPickupPeriod = data.orderTransportDtlBo.sellerConfirmPickupPeriod;
            // }
          });
        }
      });
    },
    memoSellerSubmit() {
      if (this.memoSeller == "") {
        this.$message({
          message: "请填写备注信息",
          type: "warning",
        });
        return;
      }
      this.$store
        .dispatch("orderTo/index/editOrderBySeller", {
          orderId: this.orderId,
          memoSeller: this.memoSeller,
        })
        .then((data) => {
          console.log(data);
          this.queryOrderDetail();
          this.$message("备注信息已更新");
        });
    },
    takeGoodsNumSubmit() {
      this.$store
        .dispatch("orderTo/index/editOrderBySeller", {
          orderId: this.orderId,
          takeGoodsNum: this.detail.takeGoodsNum,
        })
        .then(() => {});
    },
    orderCancel() {
      this.$prompt("请输入取消原因", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value == "") {
            this.$message({
              type: "info",
              message: "请输入取消原因",
            });
            return;
          }
          this.$store
            .dispatch("orderTo/index/toCancelOrder", {
              orderId: this.orderId,
              cancelReason: value,
            })
            .then((res) => {
              if (res.success) {
                this.$message("取消成功");
                this.queryOrderDetail();
              } else {
                this.$message({
                  type: "info",
                  message: res.errormsg,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    behalfPurchasePickup() {
      this.$confirm("你确定提货完成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("orderTo/index/editOrderBySeller", {
            orderId: this.orderId,
            orderStatus: 5,
          })
          .then((res) => {
            console.log("res: ", res);
            if (res.code != "0") {
              this.$message.error(res.msg);
              return;
            }
            this.queryOrderDetail();
            this.$message("操作成功");
          });
      });
    },
    delSellerVoucherMap(voucherMap) {
      this.$confirm("是否确认删除凭证？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          voucherMap.voucherPicList.forEach((item) => {
            this.$store
              .dispatch("orderTo/index/delOrderVoucherById", {
                id: item.id,
              })
              .then(async (res) => {
                console.log("delOrderVoucherById", res);
                if (uuidStr) {
                  await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
                    key: uuidStr,
                    val: "https://nfs.nxin.com/d6b5b4589d464682b51a6eeb77a03b3d.png",
                  });
                }
              });
          });
          this.queryOrderDetail();
        })
        .catch(() => {
          return;
        });
    },
    delSellerVoucher(id) {
      this.$confirm("是否确认删除凭证？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("orderTo/index/delOrderVoucherById", {
              id: id,
            })
            .then(async (res) => {
              console.log("delOrderVoucherById", res);
              if (uuidStr) {
                await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
                  key: uuidStr,
                  val: "https://nfs.nxin.com/d6b5b4589d464682b51a6eeb77a03b3d.png",
                });
              }
              this.queryOrderDetail();
            });
        })
        .catch(() => {
          return;
        });
    },
    // 上传图片成功之后
    uploadVoucherSuccess(res) {
      console.log("上传图片成功之后", res);
      let {
        data: { name, url },
      } = res;
      let acUrl = url;
      let logoUrl = "";
      if (this.isZip(name)) {
        logoUrl = "https://files.nxin.com/mobile/public/zip.png";
        url = logoUrl;
      }
      if (this.isWord(name)) {
        logoUrl = "https://files.nxin.com/mobile/public/word.png";
        url = logoUrl;
      }
      if (this.isPdf(name)) {
        logoUrl = "https://files.nxin.com/mobile/public/pdf.png";
        url = logoUrl;
      }
      if (this.isExcel(name)) {
        logoUrl = "https://files.nxin.com/mobile/public/excel.png";
        url = logoUrl;
      }
      const item = {
        name: name || "",
        url: url || "",
        acUrl: acUrl || "",
      };
      this.sellerVoucherPicList.push(item);
    },
    // 删除图片
    async uploadVoucherRemove(file, fileList) {
      if (uuidStr) {
        await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
          key: uuidStr,
          val: file.url,
        });
      }

      this.sellerVoucherPicList = fileList;
    },
    // 上传图片限制
    uploadVoucherExceed() {
      this.$message.warning("最多上传30张图片");
    },
    async submitSellerVoucher() {
      // 请填写提货单号非必填
      // if (this.detail.orderDtlBo.pickupCode == "" && this.detail.takeGoodsNum == "") {
      //   this.$message({
      //     message: "请填写提货单号",
      //     type: "warning",
      //   });
      //   return;
      // }
      if (this.submitSellerVoucherLoading) {
        return;
      }
      if (this.detail.takeGoodsNum != "") {
        this.takeGoodsNumSubmit();
      }
      if (this.sellerVoucherPicList.length == 0) {
        this.$message.warning("请上传文件");
        return;
      }
      let orderPurchaseVoucher = [];
      let orderVoucher = [];
      let orderVoucherNot = [];
      let promiseList = [];
      let promiseArgList = [];
      this.sellerVoucherPicList.forEach(async (item) => {
        let acUrl = item.acUrl;
        let url = item.url;
        if (acUrl) {
          url = acUrl;
        }
        let voucher = {
          fileType: "ORDER_VOUCHER_PICTURE",
          busType: "SELLER",
          refId: this.orderId,
          url: url,
        };

        promiseList.push(this.$store.dispatch("orderTo/index/checkUploadOrderVoucher", { orderId: this.orderId, voucherImgUrl: url }));
        promiseArgList.push(voucher);
      });

      this.submitSellerVoucherLoading = true;
      const resArr = await Promise.all(promiseList);
      resArr.forEach((res, index) => {
        if (res.code == "0") {
          orderVoucher.push(promiseArgList[index]);
          orderPurchaseVoucher.push(promiseArgList[index]);
        } else {
          orderVoucherNot.push(promiseArgList[index]);
        }
      });

      if (orderVoucher.length == 0 && orderVoucherNot.length > 0) {
        this.submitSellerVoucherLoading = false;
        this.$message.warning("存在不符合要求的图片，请上传提货单或司机相关图片");
        return;
      }
      if (orderVoucherNot.length > 0) {
        this.submitSellerVoucherLoading = false;
        this.$confirm("存在不符合要求的凭证，如继续上传将自动删除不符合要求的凭证，是否确认上传？", "提示", {
          confirmButtonText: "确认上传",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.addOrderVoucherSubmit(orderVoucher, orderPurchaseVoucher);
          })
          .catch(() => {
            return;
          });
        return;
      }
      this.addOrderVoucherSubmit(orderVoucher, orderPurchaseVoucher);
    },
    addOrderVoucherSubmit(orderVoucher, orderPurchaseVoucher) {
      this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderVoucher }).then((res) => {
        this.submitSellerVoucherLoading = false;
        if (res.code == "0") {
          if (this.detail.purchaseOrderId && orderPurchaseVoucher.length > 0 && this.detail.syncVoucher) {
            orderPurchaseVoucher.forEach((item) => {
              item.refId = this.detail.purchaseOrderId;
            });
            this.$store.dispatch("orderTo/index/addOrderVoucherList", { fileList: orderPurchaseVoucher });
          }
          this.$message.success("上传成功");
          this.sellerVoucherPicList = [];
          this.invoiceFileList = [];
          this.queryOrderDetail();
        } else {
          this.$message.warning("上传失败");
        }
      });
    },
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value;
    },

    // 上传图片之前
    uploadBefore(file) {
      const { size, name } = file;

      if (size == 0) {
        this.$message.warning('不能上传空文件');
        return false;
      }
      
      // 获取文件扩展名
      const fileExtension = name.substring(name.lastIndexOf('.')).toLowerCase();
      
      // 允许的文件扩展名
      const allowedExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.zip'];
      
      // 最大文件大小 50MB
      const maxSize = 50 * 1024 * 1024;
      
      // 验证文件类型
      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.warning('上传文件格式不正确，支持格式：JPG/JPEG/PNG/BMP/PDF/DOC/DOCX/XLS/XLSX/ZIP');
        return false;
      }
      
      // 验证文件大小
      if (size > maxSize) {
        this.$message.warning('上传文件大小不能超过 50MB');
        return false;
      }
      
      return true;
    },
    loadOrder() {
      this.queryOrderDetail();
    },

    isZip(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "zip";
    },

    isPdf(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "pdf";
    },

    isWord(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }

      return suffix === "doc" || suffix === "docx";
    },
    isExcel(fileUrl) {
      // 后缀获取
      let suffix = "";
      try {
        let fileArr = fileUrl.split(".");
        suffix = fileArr[fileArr.length - 1];
      } catch (err) {
        suffix = "";
        return false;
      }
      return suffix === "xls" || suffix === "xlsx";
    },

    async imgTransfer() {
      this.signatureDialogVisible = true;
      uuidStr = uuid();
      setTimeout(() => {
        QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_static}imgTransfer?uuid=${uuidStr}`);
      }, 100);

      imgTransferTimer && clearInterval(imgTransferTimer);
      imgTransferTimer = setInterval(async () => {
        const { data } = await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/sel`, {
          key: uuidStr,
        });
        if (this.sellerVoucherPicList && this.sellerVoucherPicList.length >= 30) {
          clearInterval(imgTransferTimer);
          this.$message.error("已达上传最大量");
          return;
        }
        data.valList.forEach((url) => {
          if (!this.sellerVoucherPicList.some((item) => item.url == url)) {
            this.sellerVoucherPicList.push({
              name: url.substring(0, url.lastIndexOf(".")),
              url,
            });
          }
        });
      }, 2000);
    },

    //发票上传
    // 上传图片成功之后
    uploadInvoiceSuccess(res) {
      console.log("上传图片成功之后", res);
      let {
        data: { name, url },
      } = res;
      const isPdf = /(pdf)$/.test(name);
      let acUrl = url;
      let logoUrl = "";
      if (isPdf) {
        logoUrl = "https://filesouthcdn.nxin.com/nxsc_1691545813992021546671317164323.png";
        url = logoUrl;
      }
      const item = {
        name: name || "",
        acUrl: acUrl || "",
        url: url || "",
      };
      this.invoiceFileList.push(item);
    },
    uploadInvoiceBefore(file) {
      const { size, type } = file;
      console.log("fileSize: ", size);
      console.log("fileType: ", type);
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isVerify2 = /(pdf)/.test(type);
      let isLt3M = size / 1024 / 1024 < 50;
      let sizeErr = "上传大小不能超过 50MB";
      if (!isVerify && !isVerify2) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/PDF/格式");
      } else if (!isLt3M) {
        this.$message.error(sizeErr);
      }
      return (isVerify || isVerify2) && isLt3M;
    },
    // 删除图片
    async uploadInvoiceRemove(file, fileList) {
      this.invoiceFileList = fileList;
    },
    // 上传图片限制
    uploadInvoiceExceed() {
      this.$message.warning("最多上传2张图片");
    },
    async submitInvoice() {
      console.log("submitInvoice", this.submitSellerVoucherLoading);
      if (this.submitSellerVoucherLoading) {
        return;
      }
      if (this.invoiceFileList.length == 0) {
        this.$message.warning("请上传文件");
        return;
      }
      let invoiceFile = [];
      this.invoiceFileList.forEach(async (item) => {
        let acUrl = item.acUrl;
        let name = item.name;
        invoiceFile.push({
          fileType: "ORDER_INVOICE",
          busType: "SELLER",
          refId: this.orderId,
          url: acUrl,
          name,
        });
      });

      this.$confirm("是否上传发票信息，确认后买家可以下载您上传的发票", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitSellerVoucherLoading = true;
          // this.addOrderVoucherSubmit(invoiceFile);
          this.$store.dispatch("orderTo/index/uploadInvoice", { fileList: invoiceFile }).then((res) => {
            this.submitSellerVoucherLoading = false;
            if (res.code == "0") {
              this.$message.success("上传成功");
              this.sellerVoucherPicList = [];
              this.invoiceFileList = [];
              this.queryOrderDetail();
            } else {
              this.$message.warning("上传失败");
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    delInvoicePic(id) {
      this.$confirm("是否删除已保存的发票信息？删除后买家将无法下载", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("orderTo/index/delOrderVoucherById", {
              id: id,
            })
            .then(async (res) => {
              console.log("delOrderVoucherById", res);
              this.queryOrderDetail();
            });
        })
        .catch(() => {
          return;
        });
    },

    async contractPreviewHandle(relContId) {
      console.log("this.detail", this.detail);
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { code, msg, data } = await requestApi.post(`sctrading/contract/info/getContractUrl`, {
        relContId,
      });
      loading.close();

      if (code == "0") {
        this.contractPreviewUrl = data;
        this.contractPreviewVisible = true;
      } else {
        this.$message.error(msg);
      }
    },
    allowanceHandle(data) {
      this.allowanceVisible = true;
      this.allowanceForm = {
        orderId: data.orderId,
        kbAmount: undefined,
        vehicleId: data.vehicleId,
        kbRemark: "",
      };
      this.$refs.allowanceFormRef.resetFields();
    },
    allowanceSubmit() {
      this.$refs.allowanceFormRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "提交中...",
          });
          const { code, msg } = await requestApi.post(`sctrading/order/mj/sellerPickupGoodsModify`, this.allowanceForm);
          loading.close();
          if (code == "0") {
            this.$message.success("提交成功");
            this.$refs.allowanceFormRef.resetFields();
            this.allowanceVisible = false;
            this.queryOrderDetail();
          } else {
            this.$message.error(msg);
          }
        }
      });
    }
  },
};
